module.exports = __webpack_public_path__ + "img/svg/icon-matches.d1df5b6bdc21fbe0aaeee940f0d2ac5f.svg";